import { FunctionComponent } from 'react';
import { Link, Stack, SvgIcon, Typography, useTheme } from '@mui/material';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';

import { useGetTicketsQuery } from '@/api/v2/tickets';
import { useSearchParams } from 'react-router-dom';
import { TicketsDetailsCard } from '@/pages/tickets/components/TicketsDetailsCard';

export const TicketDetailsContent: FunctionComponent = () => {
    const [searchParams] = useSearchParams();
    const { data } = useGetTicketsQuery({
        orderId: searchParams.get('id') as string,
    });
    const theme = useTheme();

    return (
        <Stack spacing={theme.page.verticalSpacing}>
            <Link
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.primary',
                    mb: 6,
                }}
                href='/tickets'
            >
                <SvgIcon
                    fontSize='small'
                    sx={{
                        mr: 2,
                    }}
                >
                    <ArrowLeftIcon />
                </SvgIcon>

                <Typography variant='subtitle2' component='span'>
                    Tickets
                </Typography>
            </Link>

            {!!data && (
                <Stack spacing={theme.page.verticalSpacing}>
                    <Typography variant='h4'>Ticket Details</Typography>

                    <TicketsDetailsCard ticket={data?.content[0]} />
                </Stack>
            )}
        </Stack>
    );
};
